/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import SquareLoader from 'components/atoms/square_loader';
import moment from 'moment';
import React, { useState } from 'react';

interface AttachmentItemProps {
  description: string;
  filename: string;
  url: string;
  createdAt: string;
  deleteItem: () => void;
}

const AttachmentItem = (props: AttachmentItemProps) => {
  const { description, filename, url, createdAt, deleteItem } = props;
  const [loadingDelete, setLoadingDelete] = useState<boolean>(false);

  const { REACT_APP_API_ENDPOINT } = process.env;

  return (
    <li className="mb-2">
      <div className="row">
        <div className="p-3 ml-3 text-black">
          <i className="material-icons display-4">file_present</i>
        </div>
        <div className="p-2">
          <p className="m-0 font-weight-bold">{description}</p>
          <small className="d-block mb-1">{filename}</small>
          <div>
            {moment(createdAt).format('DD/MM/YYYY')}
            <a
              className="mx-2"
              href={`${REACT_APP_API_ENDPOINT}${url}`}
              target="_blank"
              rel="noreferrer"
            >
              Visualizar
            </a>
            <a
              href="#"
              className="link-danger"
              onClick={() => {
                setLoadingDelete(true);
                deleteItem();
              }}
            >
              Excluir
            </a>
            {loadingDelete && <SquareLoader customClass="" />}
          </div>
        </div>
      </div>
    </li>
  );
};

export default AttachmentItem;
